import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loadingFromStore: false,
  text: []
};
export const loadingSlice = createSlice({
  name: "loadingFromStore",
  initialState,
  reducers: {
    startLoading: (state, action) => {
      state.loadingFromStore = true;
    },
    stopLoading: (state, action) => {
      state.loadingFromStore = false;
    },
    setLoadingContent: (state, action) => {

      state.text = action.payload;
    },

  },
});
// this is for dispatch
export const { startLoading, stopLoading, setLoadingContent } = loadingSlice.actions;

// this is for configureStore
export default loadingSlice.reducer;
